import { Injectable } from '@angular/core';
import { PpHttpParams, PpHttpService } from '@penpencil/common';
import { ErrorHandlerService } from 'app/core/services';
import { Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { CONVERSATION_API } from './conversation-apis';

@Injectable({
    providedIn: 'root',
})
export class ConversationService extends ErrorHandlerService {
    constructor(private ppHttpService: PpHttpService) {
        super();
    }

    getStudentList(
        page: number,
        limit: number,
        userId: string,
        name: string,
        isReadOnlyChecked?: boolean,
    ): Observable<any> {
        let params = new PpHttpParams()
            .append('type', 'SAARTHI')
            .append('page', page)
            .append('name', name)
            .append('limit', limit);

        if (isReadOnlyChecked) {
            params = params.append('unreadOnly', true);
        }

        return this.ppHttpService
            .get({
                apiPath: CONVERSATION_API.getStudentList(userId),
                params: params,
            })
            .pipe(catchError(this.handleError));
    }

    getUnresolvedChat(
        page: number,
        limit: number,
        userId: string,
    ): Observable<any> {
        return this.ppHttpService
            .get({
                apiPath: CONVERSATION_API.getUnresolvedChat(userId),
                params: new PpHttpParams()
                    .append('type', 'SAARTHI')
                    .append('page', page)
                    .append('limit', limit)
                    .append('unresolved', true),
            })
            .pipe(catchError(this.handleError));
    }

    getUnreadChat(
        page: number,
        limit: number,
        userId: string,
    ): Observable<any> {
        return this.ppHttpService
            .get({
                apiPath: CONVERSATION_API.getUnresolvedChat(userId),
                params: new PpHttpParams()
                    .append('type', 'SAARTHI')
                    .append('page', page)
                    .append('limit', limit)
                    .append('unreadOnly', true),
            })
            .pipe(catchError(this.handleError));
    }

    getChat(conversationId, query?): Observable<any> {
        query = query || {};
        return this.ppHttpService
            .get({
                apiPath: CONVERSATION_API.getChat(conversationId),
                params: query,
            })
            .pipe(retry(1), catchError(this.handleError));
    }

    sendMessage(data: any, conversationId: string): Observable<any> {
        return this.ppHttpService
            .post(data, {
                apiPath: CONVERSATION_API.sendMessage(conversationId),
            })
            .pipe(catchError(this.handleError));
    }

    addProfaneWords(conversationId, data): Observable<any> {
        return this.ppHttpService
            .put(data, {
                apiPath: CONVERSATION_API.addProfaneWords(conversationId),
            })
            .pipe(retry(1), catchError(this.handleError));
    }

    getConversationDetails(conversationId, params?): Observable<any> {
        return this.ppHttpService
            .get({
                apiPath:
                    CONVERSATION_API.getConversationDetails(conversationId),
                params: params,
            })
            .pipe(retry(1), catchError(this.handleError));
    }

    joinConversation(conversationId, data): Observable<any> {
        return this.ppHttpService
            .put(data, {
                apiPath: CONVERSATION_API.joinConversation(conversationId),
            })
            .pipe(retry(1), catchError(this.handleError));
    }

    closeConversation(conversationId, data): Observable<any> {
        return this.ppHttpService
            .put(data, {
                apiPath: CONVERSATION_API.closeConversation(conversationId),
            })
            .pipe(retry(1), catchError(this.handleError));
    }

    conversationBlockMember(
        conversationId: string,
        userId: string,
        body: { blockUser: boolean },
    ): Observable<any> {
        return this.ppHttpService
            .put(body, {
                apiPath: CONVERSATION_API.conversationBlockMember(
                    conversationId,
                    userId,
                ),
            })
            .pipe(retry(1), catchError(this.handleError));
    }

    deleteChat(conversationId, chatId): Observable<any> {
        return this.ppHttpService
            .delete({
                apiPath: CONVERSATION_API.deleteChat(conversationId, chatId),
            })
            .pipe(retry(1), catchError(this.handleError));
    }

    getUnReadMessage(conversationId: any, userId: string): Observable<any> {
        return this.ppHttpService
            .get({
                apiPath: CONVERSATION_API.getUnReadMessage(
                    conversationId,
                    userId,
                ),
            })
            .pipe(catchError(this.handleError));
    }

    updateEmojiTemplates(data: any, typeId: string): Observable<any> {
        return this.ppHttpService
            .put(data, {
                apiPath: CONVERSATION_API.updateEmojiTemplates(typeId),
            })
            .pipe(catchError(this.handleError));
    }

    getEmojiTemplates(typeId: string): Observable<any> {
        return this.ppHttpService
            .get({
                apiPath: CONVERSATION_API.getEmojiTemplates(typeId),
            })
            .pipe(catchError(this.handleError));
    }
}
